import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";
import "./payment-styles.css";

const PaymentPending = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentId =
    searchParams.get("collection_id") || searchParams.get("payment_id");

  return (
    <article className="container-payments-centered">
      <section className="form-container">
        <div className="payment-receipt-card">
          <div className="payment-header-status">
            <h2>Pago Pendiente</h2>
            <p>
              Tu transacción se encuentra en proceso de validación o espera de
              pago.
            </p>
          </div>

          <div className="receipt-details">
            <p>
              <strong>N° de Referencia:</strong> {paymentId || "N/A"}
            </p>
            <p>
              <strong>Estado:</strong> PENDIENTE
            </p>
          </div>

          <button className="btn-back-step" onClick={() => navigate("/")}>
            <ArrowIcon />
            Volver al inicio
          </button>
        </div>
      </section>
    </article>
  );
};

export default PaymentPending;
